import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="remember-param"
export default class extends Controller {
  static values = {
    key: String
  }

  connect() {
    if (!this.keyValue) {
      console.warn("remember-param controller connected but no key provided.")
      return
    }
    
    const storedValue = localStorage.getItem(this.keyValue)
    if (storedValue) {
      this.element.value = storedValue
    }
  }

  change() {
    if (this.keyValue) {
      localStorage.setItem(this.keyValue, this.element.value)
    }
  }
}
